module.exports = __webpack_public_path__ + "img/poster1.f8b1f16b.jpg";